import React from "react";

import Tag from "antd/es/tag";
import { useIntl } from "react-intl";

import { UserRef } from "@mapmycustomers/shared/types/User";
import { AvatarWithName } from "@mapmycustomers/ui";

import UserPreviewCard from "@app/component/UserPreviewCard";

import styles from "./CreatedByField.module.scss";

interface CreatedByFieldProps {
  creator: UserRef;
}

const CreatedByField = ({ creator }: CreatedByFieldProps) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div>
        {intl.formatMessage({
          id: "component.createdByField.createdBy",
          defaultMessage: "Created by",
          description: "Created by field: label",
        })}
      </div>
      <div>
        <UserPreviewCard userId={creator.id}>
          <Tag className={styles.avatar}>
            <AvatarWithName size="xs" user={creator} />
          </Tag>
        </UserPreviewCard>
      </div>
    </div>
  );
};

export default CreatedByField;
